import { TradeState } from '../../../../_shared/types/trade';

export default {
  [TradeState.upcoming]: {
    id: null,
    isAuctionEnded: false,
    upcomingProxy: null,
    auctionSummary: null,
    isWatchlisted: null
  },
  [TradeState.active]: {
    id: null,
    isAuctionEnded: false,
    upcomingProxy: null,
    auctionSummary: null,
    isWatchlisted: null
  }
};
